module.exports = __webpack_public_path__ + "right2.png?ef4ddd2af1b2155351568ff6b6aaac05";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right2.png
// module id = 606
// module chunks = 0